import React from 'react';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as moment from "moment-timezone";

const cookies = new Cookies();

const S = {
  page: { padding: 24, direction: "rtl", background: "#f8fafc", minHeight: "100vh", fontFamily: "'Segoe UI', Tahoma, sans-serif" },
  // حاوية بعرض أقصى: بلا هذا تتمدّد الجداول على الشاشات العريضة
  // فتتباعد الأعمدة ويصعب تتبّع الصف الواحد بالعين.
  // تُدمج في نمط الصفحة نفسها لتفادي تعديل بنية الـ JSX.
  // العرض الأقصى يُطبَّق عبر هوامش جانبية مرنة بدل maxWidth، كي تبقى
  // خلفية الصفحة ممتدة على كامل العرض بلا حواف رمادية.
  pageInner: {
    paddingInline: "max(24px, calc((100% - 1180px) / 2))",
    boxSizing: "border-box",
  },
  h1: { fontSize: 24, fontWeight: 800, color: "#0f172a", margin: "0 0 6px" },
  sub: { fontSize: 13, color: "#64748b", margin: "0 0 20px" },
  tabs: { display: "flex", gap: 8, marginBottom: 20, borderBottom: "2px solid #e2e8f0" },
  tab: (a) => ({ padding: "11px 22px", fontSize: 15, fontWeight: 700, cursor: "pointer", color: a ? "#2563eb" : "#64748b", borderBottom: "3px solid " + (a ? "#2563eb" : "transparent"), marginBottom: -2, transition: ".15s" }),
  card: { background: "#fff", borderRadius: 16, boxShadow: "0 1px 3px rgba(0,0,0,.08)", border: "1px solid #eef2f7", marginBottom: 16 },
  cardPad: { padding: 20 },
  grid: { display: "grid", gridTemplateColumns: "320px 1fr", gap: 20, alignItems: "start" },
  listRow: (active) => ({ padding: "13px 14px", borderRadius: 12, cursor: "pointer", marginBottom: 8, border: "1px solid", borderColor: active ? "#2563eb" : "#eef2f7", background: active ? "#eff6ff" : "#fff", transition: ".15s" }),
  badge: (bg, color) => ({ display: "inline-block", padding: "3px 11px", borderRadius: 20, fontSize: 12, fontWeight: 700, background: bg, color }),
  th: { textAlign: "right", padding: "11px 12px", fontSize: 12, color: "#64748b", fontWeight: 700, borderBottom: "2px solid #f1f5f9" },
  td: { textAlign: "right", padding: "12px", fontSize: 14, color: "#0f172a", borderBottom: "1px solid #f8fafc", verticalAlign: "top" },
  input: { padding: "10px 13px", borderRadius: 10, border: "1px solid #e2e8f0", fontSize: 14, outline: "none", fontFamily: "inherit" },
  btnPrimary: { padding: "11px 22px", borderRadius: 10, border: "none", background: "#2563eb", color: "#fff", fontWeight: 700, cursor: "pointer", fontSize: 14 },
  btnOk: { padding: "11px 22px", borderRadius: 10, border: "none", background: "#16a34a", color: "#fff", fontWeight: 700, cursor: "pointer", fontSize: 14 },
  btnDanger: { padding: "11px 22px", borderRadius: 10, border: "1px solid #fecaca", background: "#fff", color: "#dc2626", fontWeight: 700, cursor: "pointer", fontSize: 14 },
  btnGhost: { padding: "7px 14px", borderRadius: 9, border: "1px solid #e2e8f0", background: "#fff", color: "#334155", fontWeight: 600, cursor: "pointer", fontSize: 13 },
  stat: { flex: 1, minWidth: 150, padding: "16px 18px", background: "#fff", borderRadius: 14, border: "1px solid #eef2f7" },
  statLabel: { fontSize: 12, color: "#64748b", fontWeight: 600, marginBottom: 5 },
  statValue: { fontSize: 24, fontWeight: 800, color: "#0f172a" },
  chip: { display: "inline-block", padding: "3px 9px", borderRadius: 14, fontSize: 11.5, fontWeight: 600, background: "#eff6ff", color: "#2563eb", border: "1px solid #dbeafe", marginInlineEnd: 5, marginBottom: 4 },
  empty: { padding: 50, textAlign: "center", color: "#94a3b8", fontSize: 15 },
};

const fmt = (n) => {
  const v = Number(n) || 0;
  return v % 1 === 0 ? v.toLocaleString("en-US")
    : v.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export default class SpareParts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: "review",           // review | stock
      lists: [],
      selected: null,          // { list, items, grandTotal }
      loading: true,
      loadingDetail: false,
      working: false,
      // المخزن
      stock: null,
      loadingStock: false,
      stockQ: "",
      stockDev: "",
      editing: {},             // partId -> { count, price }
    };
  }

  header() { return { "Content-Type": "application/json", token: cookies.get("token") }; }

  componentDidMount() { this.loadLists(); }

  // ===================== قوائم المراجعة =====================

  loadLists = () => {
    this.setState({ loading: true });
    axios.get(host + 'sparepart/lists', { headers: this.header() })
      .then(res => {
        const lists = (res.data && res.data.data && res.data.data.lists) || [];
        this.setState({ loading: false, lists });
        const pending = lists.find(l => l.status === 'pending');
        const first = pending || lists[0];
        if (first && !this.state.selected) this.openList(first.id);
        if (!lists.length) this.setState({ selected: null });
      })
      .catch(() => { this.setState({ loading: false }); toast.error("تعذّر تحميل القوائم"); });
  };

  openList = (id) => {
    this.setState({ loadingDetail: true });
    axios.get(host + `sparepart/list/${id}`, { headers: this.header() })
      .then(res => this.setState({ loadingDetail: false, selected: (res.data && res.data.data) || null }))
      .catch(() => { this.setState({ loadingDetail: false }); toast.error("تعذّر تحميل تفاصيل القائمة"); });
  };

  approve = () => {
    const sel = this.state.selected;
    if (!sel || !sel.list) return;
    if (!window.confirm(
      `الموافقة على القائمة #${sel.list.id}؟\n` +
      `سيتم إضافة القطع للمخزن واحتساب معدّل السعر مع الكميات الموجودة.`
    )) return;

    this.setState({ working: true });
    axios.put(host + `sparepart/list/approve/${sel.list.id}`,
      { approved_by: cookies.get("name") || "" },
      { headers: this.header() })
      .then(res => {
        this.setState({ working: false });
        const data = res.data && res.data.data;
        toast.success("تمت الموافقة وإضافة القطع للمخزن");
        // عرض ملخص تغيّر المعدّل
        if (data && Array.isArray(data.items)) {
          data.items.forEach(i => {
            if (Number(i.avg_before) !== Number(i.avg_after)) {
              toast.info(`${i.part_name}: المعدّل ${fmt(i.avg_before)} ← ${fmt(i.avg_after)} (العدد ${i.count_after})`);
            }
          });
        }
        this.loadLists();
        this.openList(sel.list.id);
      })
      .catch(err => {
        this.setState({ working: false });
        toast.error((err.response && err.response.data && err.response.data.message) || "فشلت الموافقة");
      });
  };

  reject = () => {
    const sel = this.state.selected;
    if (!sel || !sel.list) return;
    if (!window.confirm(
      `رفض القائمة #${sel.list.id}؟\nسيتم حذفها بالكامل مع كل بنودها ولا يمكن التراجع.`
    )) return;

    this.setState({ working: true });
    axios.delete(host + `sparepart/list/reject/${sel.list.id}`, { headers: this.header() })
      .then(() => {
        this.setState({ working: false, selected: null });
        toast.success("تم رفض القائمة وحذفها");
        this.loadLists();
      })
      .catch(err => {
        this.setState({ working: false });
        toast.error((err.response && err.response.data && err.response.data.message) || "فشل الرفض");
      });
  };

  // ===================== المخزن =====================

  loadStock = () => {
    this.setState({ loadingStock: true });
    const p = [];
    if (this.state.stockQ.trim()) p.push("q=" + encodeURIComponent(this.state.stockQ.trim()));
    if (this.state.stockDev.trim()) p.push("device=" + encodeURIComponent(this.state.stockDev.trim()));
    const qs = p.length ? "?" + p.join("&") : "";

    axios.get(host + 'sparepart/stock' + qs, { headers: this.header() })
      .then(res => this.setState({ loadingStock: false, stock: (res.data && res.data.data) || null, editing: {} }))
      .catch(() => { this.setState({ loadingStock: false }); toast.error("تعذّر تحميل المخزن"); });
  };

  setEdit = (id, field, value) => {
    const editing = { ...this.state.editing };
    editing[id] = { ...(editing[id] || {}), [field]: value };
    this.setState({ editing });
  };

  saveAdjust = (part) => {
    const e = this.state.editing[part.id] || {};
    const count = e.count !== undefined ? Number(e.count) : Number(part.count);
    const price = e.price !== undefined ? Number(e.price) : Number(part.price);

    if (isNaN(count) || count < 0) return toast.error("العدد غير صالح");
    if (isNaN(price) || price < 0) return toast.error("السعر غير صالح");

    axios.put(host + 'sparepart/part/adjust',
      { part_id: part.id, count, price, by_name: cookies.get("name") || "" },
      { headers: this.header() })
      .then(() => { toast.success("تم التحديث"); this.loadStock(); })
      .catch(() => toast.error("فشل التحديث"));
  };

  switchTab = (tab) => {
    this.setState({ tab });
    if (tab === "stock" && !this.state.stock) this.loadStock();
  };

  // ===================== العرض =====================

  renderReview() {
    const { lists, selected, loading, loadingDetail, working } = this.state;

    if (loading) return <div style={S.empty}>جاري التحميل…</div>;

    return (
      <div style={S.grid}>

        {/* عمود القوائم */}
        <div style={{ ...S.card, ...S.cardPad }}>
          <div style={{ display: "flex", alignItems: "center", marginBottom: 14 }}>
            <div style={{ fontSize: 15, fontWeight: 800, color: "#0f172a" }}>القوائم</div>
            <button style={{ ...S.btnGhost, marginInlineStart: "auto" }} onClick={this.loadLists}>🔄</button>
          </div>

          {!lists.length && <div style={{ ...S.empty, padding: 30, fontSize: 14 }}>لا توجد قوائم</div>}

          {lists.map(l => {
            const active = selected && selected.list && selected.list.id === l.id;
            const pending = l.status === 'pending';
            return (
              <div key={l.id} style={S.listRow(active)} onClick={() => this.openList(l.id)}>
                <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
                  <b style={{ fontSize: 14, color: "#0f172a" }}>#{l.id}</b>
                  <span style={S.badge(
                    pending ? "#fffbeb" : "#f0fdf4",
                    pending ? "#d97706" : "#16a34a"
                  )}>{pending ? "قيد المراجعة" : "معتمدة"}</span>
                </div>
                <div style={{ fontSize: 13, color: "#334155", marginBottom: 4 }}>{l.title}</div>
                <div style={{ fontSize: 11.5, color: "#94a3b8" }}>
                  {l.itemsCount != null ? `${l.itemsCount} بند · ` : ""}
                  {fmt(l.total)} · {moment(l.createdAt).format("YYYY/MM/DD")}
                </div>
                {l.created_by_name ? (
                  <div style={{ fontSize: 11.5, color: "#94a3b8", marginTop: 3 }}>
                    بواسطة: {l.created_by_name}
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>

        {/* تفاصيل القائمة */}
        <div>
          {loadingDetail && <div style={{ ...S.card, ...S.empty }}>جاري التحميل…</div>}

          {!loadingDetail && !selected && (
            <div style={{ ...S.card, ...S.empty }}>اختر قائمة لعرض تفاصيلها</div>
          )}

          {!loadingDetail && selected && selected.list && (() => {
            const list = selected.list;
            const rows = selected.items || [];
            const pending = list.status === 'pending';

            return (
              <React.Fragment>
                <div style={{ ...S.card, ...S.cardPad }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
                    <div>
                      <div style={{ fontSize: 18, fontWeight: 800, color: "#0f172a" }}>
                        {list.title} <span style={{ color: "#94a3b8", fontWeight: 600 }}>#{list.id}</span>
                      </div>
                      <div style={{ fontSize: 12.5, color: "#64748b", marginTop: 4 }}>
                        {list.created_by_name ? `أنشأها: ${list.created_by_name} · ` : ""}
                        {moment(list.createdAt).format("YYYY/MM/DD HH:mm")}
                        {list.approved_by ? ` · اعتمدها: ${list.approved_by}` : ""}
                      </div>
                    </div>

                    <div style={{ marginInlineStart: "auto", display: "flex", gap: 10, alignItems: "center" }}>
                      <div style={{ textAlign: "center", marginInlineEnd: 10 }}>
                        <div style={{ fontSize: 11.5, color: "#64748b", fontWeight: 600 }}>الإجمالي</div>
                        <div style={{ fontSize: 21, fontWeight: 800, color: "#2563eb" }}>
                          {fmt(selected.grandTotal)}
                        </div>
                      </div>

                      {pending ? (
                        <React.Fragment>
                          <button style={{ ...S.btnOk, opacity: working ? .6 : 1 }}
                            disabled={working} onClick={this.approve}>
                            ✓ قبول وإضافة للمخزن
                          </button>
                          <button style={{ ...S.btnDanger, opacity: working ? .6 : 1 }}
                            disabled={working} onClick={this.reject}>
                            ✕ رفض وحذف
                          </button>
                        </React.Fragment>
                      ) : (
                        <span style={S.badge("#f0fdf4", "#16a34a")}>معتمدة — دخلت المخزن</span>
                      )}
                    </div>
                  </div>
                </div>

                <div style={S.card}>
                  <div style={{ overflowX: "auto" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr>
                        <th style={{ ...S.th, width: 45 }}>#</th>
                        <th style={S.th}>القطعة</th>
                        <th style={S.th}>الأجهزة المتوافقة</th>
                        <th style={{ ...S.th, width: 80 }}>العدد</th>
                        <th style={{ ...S.th, width: 110 }}>سعر الوحدة</th>
                        <th style={{ ...S.th, width: 120 }}>الإجمالي</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!rows.length && (
                        <tr><td colSpan={6} style={S.empty}>لا توجد بنود</td></tr>
                      )}
                      {rows.map((r, i) => (
                        <tr key={r.id}>
                          <td style={S.td}>{i + 1}</td>
                          <td style={S.td}>
                            <b>{r.part_name}</b>
                            {r.notes ? <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 3 }}>{r.notes}</div> : null}
                          </td>
                          <td style={S.td}>
                            {(r.devices || []).map((d, k) => (
                              <span key={k} style={S.chip}>{d}</span>
                            ))}
                            {!(r.devices || []).length && <span style={{ color: "#cbd5e1" }}>—</span>}
                          </td>
                          <td style={S.td}>{fmt(r.qty)}</td>
                          <td style={S.td}>{fmt(r.price)}</td>
                          <td style={{ ...S.td, fontWeight: 700 }}>{fmt(r.total)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  </div>
                </div>
              </React.Fragment>
            );
          })()}
        </div>
      </div>
    );
  }

  renderStock() {
    const { stock, loadingStock, stockQ, stockDev } = this.state;

    return (
      <div>
        <div style={{ ...S.card, ...S.cardPad, display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center" }}>
          <input style={{ ...S.input, flex: 1, minWidth: 200 }}
            placeholder="بحث باسم القطعة (شاشة، بطارية…)"
            value={stockQ}
            onChange={e => this.setState({ stockQ: e.target.value })}
            onKeyDown={e => { if (e.key === "Enter") this.loadStock(); }} />
          <input style={{ ...S.input, flex: 1, minWidth: 200 }}
            placeholder="فلترة بالجهاز (iPad 5)"
            value={stockDev}
            onChange={e => this.setState({ stockDev: e.target.value })}
            onKeyDown={e => { if (e.key === "Enter") this.loadStock(); }} />
          <button style={S.btnPrimary} onClick={this.loadStock}>بحث</button>
        </div>

        {stock && (
          <div style={{ display: "flex", gap: 14, marginBottom: 16, flexWrap: "wrap" }}>
            <div style={S.stat}>
              <div style={S.statLabel}>أنواع القطع</div>
              <div style={S.statValue}>{stock.count}</div>
            </div>
            <div style={S.stat}>
              <div style={S.statLabel}>إجمالي القطع</div>
              <div style={S.statValue}>{fmt(stock.total_units)}</div>
            </div>
            <div style={S.stat}>
              <div style={S.statLabel}>قيمة المخزون</div>
              <div style={{ ...S.statValue, color: "#16a34a" }}>{fmt(stock.total_value)}</div>
            </div>
          </div>
        )}

        <div style={S.card}>
          {loadingStock && <div style={S.empty}>جاري التحميل…</div>}

          {!loadingStock && (
            <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th style={S.th}>القطعة</th>
                  <th style={S.th}>الأجهزة المتوافقة</th>
                  <th style={{ ...S.th, width: 110 }}>العدد</th>
                  <th style={{ ...S.th, width: 130 }}>معدّل التكلفة</th>
                  <th style={{ ...S.th, width: 120 }}>القيمة</th>
                  <th style={{ ...S.th, width: 90 }}></th>
                </tr>
              </thead>
              <tbody>
                {(!stock || !stock.parts || !stock.parts.length) && (
                  <tr><td colSpan={6} style={S.empty}>لا توجد قطع في المخزن</td></tr>
                )}
                {stock && (stock.parts || []).map(p => {
                  return (
                    <tr key={p.id}>
                      <td style={S.td}><b>{p.name}</b></td>
                      <td style={S.td}>
                        {(p.devices || []).map((d, k) => <span key={k} style={S.chip}>{d}</span>)}
                        {!(p.devices || []).length && <span style={{ color: "#cbd5e1" }}>—</span>}
                      </td>
                      <td style={{ ...S.td, fontWeight: 700 }}>{fmt(p.count)}</td>
                      <td style={S.td}>{fmt(p.price)}</td>
                      <td style={{ ...S.td, fontWeight: 700 }}>{fmt(p.total_value)}</td>
                      <td style={S.td}></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            </div>
          )}
        </div>
      </div>
    );
  }

  render() {
    const { tab } = this.state;
    return (
      <div style={{ ...S.page, ...S.pageInner }}>
        <ToastContainer position="bottom-left" autoClose={4000} rtl />

        <h1 style={S.h1}>قطع الغيار</h1>
        <p style={S.sub}>
          مراجعة القوائم القادمة من محطة الفحص وإدارة مخزن قطع الغيار.
          عند القبول يُحتسب معدّل التكلفة المرجّح مع الكمية الموجودة سابقاً.
        </p>

        <div style={S.tabs}>
          <div style={S.tab(tab === "review")} onClick={() => this.switchTab("review")}>
            مراجعة القوائم
          </div>
          <div style={S.tab(tab === "stock")} onClick={() => this.switchTab("stock")}>
            مخزن قطع الغيار
          </div>
        </div>

        {tab === "review" ? this.renderReview() : this.renderStock()}
      </div>
    );
  }
}
